import React, { useState } from "react";
import { Toast, ToastContainer, Button } from "react-bootstrap";
import { FiBell, FiSettings, FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { adminLogout } from "../../store/AdminAuthSlice";

const AdminTopbar = ({ sidebarOpen }) => {
  const [showToast, setShowToast] = useState(false);
  const [toastContent, setToastContent] = useState({ title: "", body: "" });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleShowToast = (type) => {
    if (type === "notifications")
      setToastContent({
        title: "Notifications",
        body: "No new notifications yet!",
      });
    else if (type === "settings")
      setToastContent({
        title: "Profile",
        body: (
          <Button
            variant="link"
            onClick={() => {
              navigate("/admin/profile");
              setShowToast(false);
            }}
          >
            Go to Profile
          </Button>
        ),
      });
    else if (type === "logout")
      setToastContent({
        title: "Logout",
        body: (
          <Button
            variant="danger"
            size="sm"
            onClick={() => {
              dispatch(adminLogout());
              navigate("/admin/login", { replace: true });
              setShowToast(false);
            }}
          >
            Confirm Logout
          </Button>
        ),
      });

    setShowToast(true);
  };

  return (
    <>
      <div
        className={`ad-topbar ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
      >
        <div className="ad-topbar-left"></div>
        <div className="ad-topbar-right">
          <FiBell
            size={22}
            className="ad-icon"
            onClick={() => handleShowToast("notifications")}
          />
          <FiSettings
            size={22}
            className="ad-icon"
            onClick={() => handleShowToast("settings")}
          />
          <FiLogOut
            size={22}
            className="ad-icon"
            onClick={() => handleShowToast("logout")}
          />
        </div>
      </div>

      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={4000}
          autohide
        >
          <Toast.Header closeButton>
            <strong className="me-auto">{toastContent.title}</strong>
          </Toast.Header>
          <Toast.Body>{toastContent.body}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default AdminTopbar;
